import AnimateIntoView from 'components/AnimateIntoView'
import { CallToAction } from 'components/CallToAction'
import { SignupCTA } from 'components/SignupCTA'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { prepareData } from 'utils/googleData'

export function FooterCTA(props) {
        const { enable, title, subtitle, text, cta, direction, style, lottie, gatsbyImage, gatsbyImageSrc, plans,location, Icon } = prepareData({
                    props,
                })
if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
                    return <></>
                }
    return (
        <div direction={direction} className="flex flex-col lg:flex-row justify-between py-12 px-6 sm:px-12 bg-primary dark:bg-gray-accent-dark items-center dark rounded-[10px] mt-12">
            <div>
                <h2 className="text-white text-5xl">{title}</h2>
                <p className="text-white w-">{subtitle}</p>
         {cta?.url &&       <div className="flex flex-col sm:flex-row sm:space-x-2 space-y-2 sm:space-y-0">
                    <SignupCTA className="w-full sm:w-48" />
                    <CallToAction to={cta?.url } type="secondary" className="w-full sm:w-48 ">
                       {cta?.label}
                    </CallToAction>
                </div> }
            </div>
            <div className="flex-shrink-0 self-end relative ml-12 -mb-12 -mr-10 mt-16 lg:mt-0">
            {Icon &&    <AnimateIntoView className="absolute -left-20">
                    <Icon />
                </AnimateIntoView> }
           {gatsbyImage   &&  <GatsbyImage width={252} image={gatsbyImage} /> }
            </div>
        </div>
    )
}
export default FooterCTA
